import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/19164d6e6195eaf5ae2814b8eb9e837d/b21da5b5beaa9f1c2b8f95803a5f984f.jpeg"
          alt="Luxury Property"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/55" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-8 w-full max-w-4xl mx-auto">
        <p
          className="section-label text-amber-100/60 mb-8 animate-fade-up tracking-widest"
          style={{ animationDelay: "0.2s" }}
        >
          Single Property Digital Branding
        </p>

        <h1
          className="font-serif text-5xl md:text-7xl lg:text-8xl font-medium text-amber-50 leading-tight mb-6 animate-fade-up drop-shadow-sm"
          style={{ animationDelay: "0.4s" }}
        >
          Vom Inserat
          <br />
          <span className="italic text-gold-light font-normal">zur Ikone.</span>
        </h1>

        <span
          className="gold-divider mb-8 animate-fade-in"
          style={{ animationDelay: "0.7s" }}
        />

        <p
          className="text-amber-100/75 font-sans font-light text-lg md:text-xl leading-relaxed mb-12 animate-fade-up max-w-2xl mx-auto"
          style={{ animationDelay: "0.8s" }}
        >
          Wir verwandeln Premium-Immobilien in digitale Erlebnisse.
        </p>

        <div
          className="flex flex-col sm:flex-row items-center justify-center gap-5 animate-fade-up"
          style={{ animationDelay: "1s" }}
        >
          <Link to="/gallery" className="btn-gold-fill">
            Galerie entdecken
          </Link>
          <Link
            to="/kontakt"
            className="inline-flex items-center gap-3 px-7 py-3 rounded-full border border-amber-100/25 hover:border-gold/70 text-amber-100/70 hover:text-amber-50 text-xs tracking-luxury font-sans font-medium uppercase transition-all duration-400 cursor-pointer whitespace-nowrap group"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-gold/70 group-hover:bg-gold flex-shrink-0 transition-colors duration-300" />
            Projekt anfragen
          </Link>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div
        className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-fade-in"
        style={{ animationDelay: "1.4s" }}
      >
        <span className="text-xs tracking-luxury font-sans text-amber-100/30 uppercase">Scroll</span>
        <div className="w-px h-10 bg-gradient-to-b from-white/30 to-transparent" />
      </div>
    </section>
  );
}
